import OrganizationSearch from './OrganizationSearch';

const OrganizationCard = () => {
  return (
    <div className="card">
      <h3 className="card-title">Organization</h3>
      <OrganizationSearch />
    </div>
  );
};

export default OrganizationCard;
